import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconSocialMediaX.module.css';

/**
 * The X (formerly Twitter) logo. Lucide has no brand logos, so this one is ours; its colour comes
 * from the CSS fill (ink by default, white where a page asks for it with rootClassName).
 */
const IconSocialMediaX = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
};

IconSocialMediaX.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

IconSocialMediaX.propTypes = { rootClassName: string, className: string };

export default IconSocialMediaX;
